import { useEffect, useState } from "react";
import { useInterval, useTimeout } from "usehooks-ts";


const TypeWriter = ({ text, textList, className, style, delay = 2000, textSpeed = 80, pointerBlinkRate = 1000, ttl = 5000 }) => {

  if (text && textList) {
    throw new Error('TypeWriter component cannot have both text and textList props.');
  }


  const [wordList, setWordList] = useState(text ? [text] : textList);

  const [shownText, setShownText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [currentWord, setCurrentWord] = useState(' ');


  // Resets shownText when wordList changes.
  useEffect(() => {
    setShownText('');
    setWordIndex(0);
  }, [wordList])

  // Changes currentWord when wordIndex changes.
  useEffect(() => {
    setCurrentWord(wordList[wordIndex]);
  }, [wordList, wordIndex])

  const [expanding, setExpanding] = useState(false);


  // Delays the start of the animation.
  useTimeout(() => {
    setExpanding(true);
  }, delay)


  useInterval(() => {
    if (expanding) {
      // Adds a character to shownText every textSpeed.
      setShownText(currentWord.substring(0, shownText.length + 1));
    } else {
      // Removes a character from shownText every textSpeed.
      setShownText(currentWord.substring(0, shownText.length - 1));
    }
  }, textSpeed)

  useEffect(() => {
    setTimeout(() => {
      if (expanding === true && shownText.length === currentWord.length) {
        setExpanding(false);
      }
    }, ttl);
  }, [currentWord, shownText, ttl, expanding])

  useEffect(() => {
    setTimeout(() => {
      if (expanding === false && shownText.length === 0) {
        setExpanding(true);

        if (wordIndex === wordList.length - 1) {
          setWordIndex(0);
        } else {
          setWordIndex((wordIndex) => wordIndex + 1)
        }
      }
    }, 1000);
  }, [expanding, shownText, wordIndex, wordList])


















  const [pointer, setPointer] = useState('_');
  // Toggles the pointer every 1000ms when all of prop text is shown.
  useEffect(() => {
    if (shownText.length === currentWord.length) {
      setTimeout(() => {
        if (pointer === '_') {
          setPointer('');
        } else {
          setPointer('_');
        }
      }, pointerBlinkRate);
    } else {
      setPointer('_');
    }
  }, [shownText, pointer, currentWord, pointerBlinkRate])

  return (
    <text className={className} style={style}>{shownText}{pointer} </text>
  )

}

export default TypeWriter;